module.exports = __webpack_public_path__ + "img/authe-4.7e90abf.jpg";